<template>
  <div class="CadastroUsuarios">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/orcamentos' }">Orçamento Painel</el-breadcrumb-item>
          <el-breadcrumb-item>Novo Orçamento Painel</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-tabs type="card" style="margin-top:20px;">
      <el-tab-pane label="Negócio">
        <!-- ABA NEGÓCIO -->
        <el-row :gutter="10" type="flex" justify="center">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              :label-position="labelPosition"
            >
              <el-row justify="left">
                <el-col class="encontrar_orc_left" :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
                  <encontrarOrcamento v-on:negocio-click="onNegocioClick"></encontrarOrcamento>
                </el-col>
              </el-row>
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                  <el-form-item label="Nº do Negócio" prop="numero_negocio">
                    <el-input
                      v-model.number="ruleForm.numero_negocio"
                      v-on:blur="buscaNumeroNegocio"
                      type="number"
                    >
                      <el-button
                        slot="append"
                        v-on:click="buscaNumeroNegocio"
                        icon="el-icon-search"
                      ></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6" :lg="8" :xl="8">
                  <el-form-item label="Revisão" prop="revisao">
                    <el-input v-model.number="ruleForm.revisao" type="number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Comissão Interna" prop="comissao">
                    <money
                      v-model="ruleForm.comissao"
                      v-bind="money"
                      class="el-input el-input__inner"
                    ></money>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Comissão Externa" prop="comissao_externa">
                    <money
                      v-model="ruleForm.comissao_externa"
                      v-bind="money"
                      class="el-input el-input__inner"
                    ></money>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13">
                  <el-form-item label="Cliente" prop="cliente" class="listas">
                    <el-select
                      v-model="ruleForm.sge_cliente"
                      filterable
                      v-on:change="buscaCidadesClientes"
                      placeholder="Informe o Cliente"
                    >
                      <el-option
                        v-for="item in listClientes"
                        :key="item.CODIGO"
                        :label="item.RAZAO_SOCIAL"
                        :value="item.CODIGO"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item v-show="esconder_campos_hidden" prop="sge_cliente">
                    <el-input v-model="ruleForm.sge_cliente"></el-input>
                  </el-form-item>
                  <el-form-item label="Cliente" prop="cliente">
                    <el-input v-model="ruleForm.cliente" :disabled="true"></el-input>
                  </el-form-item>-->
                </el-col>
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Estado" prop="estado" class="listas">
                    <el-select
                      v-model="ruleForm.estado"
                      v-on:change="buscaCidades"
                      filterable
                      placeholder="Informe o Estado"
                    >
                      <el-option
                        v-for="item in listEstados"
                        :key="item.value"
                        :label="item.descricao"
                        :value="item.sigla"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item v-show="esconder_campos_hidden" prop="sge_estado">
                    <el-input v-model="ruleForm.sge_estado"></el-input>
                  </el-form-item>
                  <el-form-item label="Estado" prop="estado">
                    <el-input v-model="ruleForm.estado" :disabled="true"></el-input>
                  </el-form-item>-->
                </el-col>
                <el-col :xs="24" :sm="16" :md="18" :lg="7" :xl="7">
                  <el-form-item label="Cidade" prop="cidade" class="listas">
                    <el-select v-model="ruleForm.cidade" filterable placeholder="Informe a Cidade">
                      <el-option
                        v-for="item in listCidades"
                        :key="item.value"
                        :label="item.descricao"
                        :value="item.descricao"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item v-show="esconder_campos_hidden" prop="sge_cidade">
                    <el-input v-model="ruleForm.sge_cidade"></el-input>
                  </el-form-item>
                  <el-form-item label="Cidade" prop="cidade">
                    <el-input v-model="ruleForm.cidade" :disabled="true"></el-input>
                  </el-form-item>-->
                </el-col>
              </el-row>
              <el-row v-show="esconder_campos_hidden" :gutter="10" justify="left">
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="4">
                  <el-form-item label="Rentabilidade Desejada" prop="rentabilidade">
                    <el-input v-model="ruleForm.rentabilidade" :disabled="true">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light"></div>
                </el-col>
              </el-row>
              <el-row>
                <el-col class="lista_ncm" :span="24">
                  <listaNcm v-on:ncm-click="onNcmClick"></listaNcm>
                </el-col>
              </el-row>

              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="12" :md="7" :lg="7" :xl="7">
                  <el-form-item label="NCM" prop="ncm">
                    <el-input
                      v-model="ruleForm.ncm"
                      v-on:blur="buscaNcm"
                      v-mask="['#', '##', '###', '####', '####.#', '####.##', '####.##.#', '####.##.##']"
                    >
                      <el-button slot="append" v-on:click="buscaNcm" icon="el-icon-search"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="13" :lg="13" :xl="13">
                  <el-form-item label="Descrição NCM" prop="ncm_descricao">
                    <el-input v-model="ruleForm.ncm_descricao" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                  <el-form-item label="% IPI" prop="ipi">
                    <el-input v-model="ruleForm.ipi" :disabled="true">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light"></div>
                </el-col>
              </el-row>

              <el-row :gutter="10" style="margin-top:20px" justify="center">
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Benefício PIS/COFINS?" prop="beneficio1">
                    <el-switch
                      v-model="ruleForm.beneficio1"
                      active-text="Sim"
                      v-on:change="verificaBeneficio"
                      inactive-text="Não"
                      active-color="#ff4949"
                      inactive-color="#66CC99"
                    ></el-switch>
                  </el-form-item>
                </el-col>
                <!-- <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Benefício IRPJ?" prop="beneficio2">
                    <el-switch
                      v-model="ruleForm.beneficio2"
                      active-text="Sim"
                      v-on:change="verificaBeneficio"
                      inactive-text="Não"
                      active-color="#ff4949"
                      inactive-color="#66CC99"
                    ></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Benefício CSLL?" prop="beneficio3">
                    <el-switch
                      v-model="ruleForm.beneficio3"
                      active-text="Sim"
                      v-on:change="verificaBeneficio"
                      inactive-text="Não"
                      active-color="#ff4949"
                      inactive-color="#66CC99"
                    ></el-switch>
                  </el-form-item>
                </el-col>-->
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Benefício IPI?" prop="beneficio4">
                    <el-switch
                      v-model="ruleForm.beneficio4"
                      active-text="Sim"
                      v-on:change="verificaBeneficio"
                      inactive-text="Não"
                      active-color="#ff4949"
                      inactive-color="#66CC99"
                    ></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Fabricante no RS?" prop="beneficio5">
                    <el-switch
                      v-model="ruleForm.beneficio5"
                      active-color="#ff4949"
                      inactive-color="#66CC99"
                      v-on:change="verificaBeneficio"
                      active-text="Sim"
                      inactive-text="Não"
                      :disabled="desabilita_tec_dig"
                    ></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <!-- FINAL ABA NEGOCIO -->
      </el-tab-pane>
      <el-tab-pane label="Custos">
        <!-- ABA CUSTOS -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-row :gutter="10" style="margin-top:0px;">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top:0px;">
                  <el-row style="margin-top:0px;">
                    <el-col :span="24" style=" padding:0px;">
                      <OrcamentoCmo v-on:cmo-click="onCmoClick"></OrcamentoCmo>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top:0px;">
                    <el-col class="tabela_cmo" :span="24" style="margin-top:0px;">
                      <el-table
                        :data="listCmo"
                        style="width: 100%;margin-top:0px;"
                        :summary-method="getTotais"
                        show-summary
                      >
                        <el-table-column prop="funcao" label="Função" width="140">
                          <template slot-scope="scope">{{listCmo[scope.$index].funcao}}</template>
                        </el-table-column>
                        <el-table-column
                          style="width: 100%;margin-top:0px;"
                          prop="carga_horaria"
                          width="1px"
                        >
                          <template slot-scope="scope">
                            <el-input
                              v-model="listCmo[scope.$index].carga_horaria"
                              :disabled="true"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column prop="hora_normal" label="Horas Normais">
                          <template slot-scope="scope">
                            <el-input
                              v-model="listCmo[scope.$index].hora_normal"
                              v-mask="['#', '##', '###', '####', '#####', '######']"
                              v-on:blur="calculaTotal"
                              :tabindex="tabulacao(scope.$index)"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column prop="hora_extra_50" label="Hr. Extra 50%">
                          <template slot-scope="scope">
                            <el-input
                              v-model="listCmo[scope.$index].hora_extra_50"
                              v-mask="['#', '##', '###', '####', '#####', '######']"
                              v-on:blur="calculaTotal"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column prop="hora_extra_100" label="Hr. Extra 100%">
                          <template slot-scope="scope">
                            <el-input
                              v-model="listCmo[scope.$index].hora_extra_100"
                              v-mask="['#', '##', '###', '####', '#####', '######']"
                              v-on:blur="calculaTotal"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column prop="total" label="Total" width="200px">
                          <template slot-scope="scope">
                            <span class="input_campos">R$ {{listCmo[scope.$index].total}}</span>
                            <!-- <el-input v-model="listCmo[scope.$index].total" :disabled="true"></el-input> -->
                          </template>
                        </el-table-column>
                        <el-table-column label="Ação" width="70px" filter-placement="bottom-end">
                          <template slot-scope="scope">
                            <el-tooltip
                              class="item"
                              effect="light"
                              content="Excluir"
                              placement="top"
                            >
                              <el-button
                                size="mini"
                                type="danger"
                                @click="handleDeleteCmo(scope.$index)"
                                icon="el-icon-delete"
                              ></el-button>
                            </el-tooltip>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-row>
                <el-col :xs="24" :sm="24" :md="20" :lg="24" :xl="24">
                  <h4>Custo Mão de Obra Painéis</h4>
                </el-col>
              </el-row>
              <el-row :gutter="10" type="flex" justify="center">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-table
                    :data="tab_tributos"
                    style="width: 100%"
                    show-summary
                    :summary-method="getTotaisTributos"
                  >
                    <el-table-column label="Tributos">
                      <el-table-column prop="descricao" label="Descrição" width="180"></el-table-column>
                      <el-table-column prop="percentual" label="Percentual" width="180"></el-table-column>
                      <el-table-column prop="valor" label="Valor" width="180"></el-table-column>
                    </el-table-column>
                  </el-table>
                  <br />
                  <br />
                  <el-alert
                    v-if="mostra_msg_tecdig"
                    title="Tecnologia Digital!"
                    type="success"
                    :description="ruleForm.info_tecdig"
                    :closable="false"
                  ></el-alert>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col style="padding:0px; margin:0px; " :span="24">
                  <h4 style="padding:0px;  margin:0px; margin-top:20px;">Custos Diversos</h4>
                </el-col>
              </el-row>
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="ART" prop="art">
                    <money
                      :tabindex="8"
                      v-model="ruleForm.art"
                      v-bind="money"
                      class="el-input el-input__inner"
                    ></money>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Outros" prop="outros">
                    <money
                      :tabindex="9"
                      v-model="ruleForm.outros"
                      v-bind="money"
                      class="el-input el-input__inner"
                    ></money>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" class="espaco_top">
                  <span class="label_campos">Total</span>
                  <span class="input_campos">R$ {{ruleForm.total_diversos}}</span>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" class="espaco_top">
                  <span class="label_campos">Total M.O.</span>
                  <span class="input_campos">R$ {{ruleForm.totalGeral}}</span>
                </el-col>
              </el-row>

              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Custo Matéria-Prima" prop="cmp">
                    <money
                      :tabindex="10"
                      v-model="ruleForm.cmp"
                      v-bind="money"
                      class="el-input el-input__inner"
                    ></money>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-form-item label="Faturamento Direto" prop="faturamento_direto">
                    <money
                      :tabindex="12"
                      v-model="ruleForm.faturamento_direto"
                      v-bind="money"
                      class="el-input el-input__inner"
                    ></money>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" class="espaco_top">
                  <span class="label_campos">Total Matéria-Prima</span>
                  <span class="input_campos">R$ {{ruleForm.total_materia_prima}}</span>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" class="espaco_top">
                  <span class="label_campos">Custo Total</span>
                  <span class="input_campos">R$ {{ruleForm.custo_total}}</span>
                </el-col>
              </el-row>
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                  <el-button @click="calculaTotais" :tabindex="13" type="primary" round>Simular</el-button>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24" style="margin-top:10px">
                  <el-button @click="handleFechar()">Voltar</el-button>
                  <el-button
                    :disabled="esconde_botao"
                    :tabindex="14"
                    type="primary"
                    @click="submitForm('ruleForm')"
                  >Finalizar Orçamento</el-button>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-light"></div>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="padding:0px; margin:0px; margin-top:20px;" :span="24">
                  <h4 style="padding:0px;  margin:0px">Total Geral</h4>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="7" class="espaco_top">
                  <span class="label_campos">ICMS</span>
                  <span class="input_campos">{{tab_tributos[4].percentual}}</span>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="7" class="espaco_top">
                  <span class="label_campos">IPI</span>
                  <span class="input_campos">{{tab_tributos[0].percentual}}</span>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="7" class="espaco_top">
                  <span class="label_campos">NCM</span>
                  <span class="input_campos">{{ruleForm.ncm}}</span>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col
                  :xs="24"
                  :sm="24"
                  :md="12"
                  :lg="12"
                  :xl="12"
                  style="margin-top:28px"
                  class="espaco_top"
                >
                  <span class="label_campos">Total Sem IPI</span>
                  <span class="input_campos_total">R$ {{ruleForm.valor_venda_sem_ipi}}</span>
                </el-col>
                <el-col
                  :xs="24"
                  :sm="24"
                  :md="12"
                  :lg="12"
                  :xl="12"
                  style="margin-top:28px"
                  class="espaco_top"
                >
                  <span class="label_campos">Total Com IPI</span>
                  <span class="input_campos_total">R$ {{ruleForm.valor_venda_com_ipi}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <!-- FINAL ABA CUSTOS -->
      </el-tab-pane>
      <el-tab-pane label="Painel  ">
        <el-row :gutter="10" type="flex" justify="left">

          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              :label-position="labelPosition"
            >
                  <el-form-item label="Nº do Negócio" prop="numero_negocio">
                    <el-input
                      v-model.number="ruleForm.numero_negocio"
                      type="number"
                    >
                      <el-button
                        slot="append"
                        v-on:click="buscarPainelOrcamentoNumero"
                        icon="el-icon-search"
                      ></el-button>
                    </el-input>
                  </el-form-item>
            </el-form>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-button
                v-on:click="buscarPainelOrcamentoItemSGE"
                icon="el-icon-search"
              > Pesquisar Orçamento Painel SGE #2</el-button>
          </el-col>

        </el-row>

        <el-row style="margin-top:0px;">
          <el-col class="tabela_cmo" :span="24" style="margin-top:0px;">
            <el-table
              :data="listCmo"
              style="width: 100%;margin-top:0px;"
              :summary-method="getTotais"
              show-summary
            >
              <el-table-column prop="funcao" label="Função" width="140">
                <template slot-scope="scope">{{listCmo[scope.$index].funcao}}</template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        

      </el-tab-pane>


    </el-tabs>
  </div>
</template>
<script>
import ListaNcm from "@/components/orcamentos/ListaNcm.vue";
import EncontrarOrcamento from "@/components/orcamentos/EncontrarOrcamento.vue";
import OrcamentoCmo from "@/components/orcamentos/OrcamentoCmo.vue";
import { Money } from "v-money";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
  components: {
    ListaNcm,
    EncontrarOrcamento,
    OrcamentoCmo,
    Money,
  },

  data() {
    return {
      mostra_msg_tecdig:false,
      //////////////////PAINEIS////////////////////////////
      listClientes: [],
      listEstados: [],
      listCidades: [],
      listTodasCidades: [],
      desabilita_tec_dig: true,
      // testeValidacao: true,
      percentual_ipi: 0,
      percentual_rentabilidade_desejada: 0,
      valor_rentabilidade_desejada: 0,
      icms_tec_dig: 0,
      totalCusto: 0,
      totalTributos: 0,
      tab_custos: [
        {
          custo: "Matéria-Prima",
          valor: "0,00",
        },
        {
          custo: "Mão-de-Obra",
          valor: "0,00",
        },
        {
          custo: "Comissões",
          valor: "0,00",
        },
      ],
      tab_tributos: [
        {
          slug: "ipi",
          descricao: "IPI",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "irpj",
          descricao: "IRPJ",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "csll",
          descricao: "CSLL",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "pis_cofins",
          descricao: "PIS/COFINS",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "icms",
          descricao: "ICMS",
          percentual: "0,00",
          valor: "0,00",
        },
      ],
      tab_tributos_config: [
        {
          slug: "ipi", //0
          descricao: "IPI",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "irpj", //1
          descricao: "IRPJ",
          percentual: "1,53",
          valor: "0,00",
        },
        {
          slug: "csll", //2
          descricao: "CSLL",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "pis_cofins", //3
          descricao: "PIS/COFINS",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "icms", //4
          descricao: "ICMS",
          percentual: "0,00",
          valor: "0,00",
        },
      ],
      ////////////////////////////////////////////////////
      //      value: "1000",
      ///////////////////////////
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: true /* doesn't work with directive */,
      },
      percentual: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        suffix: "%",
        masked: true /* doesn't work with directive */,
      },
      esconder_campos_hidden: false,
      esconde_botao: false,
      //////////////
      credito_pis_cofins: "",
      veriftotalGeral: "",
      /////////////
      ////select
      list_tec_digital: [],
      loading: false,
      listCmo: [],
      permissao: {},
      ///fim select
      labelPosition: "right",
      ruleForm: {
        numero_negocio: "",
        revisao: "",
        comissao: "",
        cliente: "",
        cidade: "",
        estado: "",
        rentabilidade: "",
        ncm: "",
        ncm_descricao: "",
        ipi: "",  //ipi buscado do ncm, só será este valor se marcado não nos beneficios, caso contrario será 0 na tabela de impostos Catana 05-11-20
        tec_dig_id: "",
        tec_dig_desc: "",
        beneficio1: false,
        beneficio2: false,
        beneficio3: false,
        beneficio4: false,
        beneficio5: false,
        art: "",
        outros: "",
        total_diversos: "",
        totalGeral: "",
        cmp: "", //custo materia-prima
        credito_pis_cofins: "",
        array_dados: [],
        faturamento_direto: "",
        percentual_faturamento_direto: "",
        comissao_externa: "",
        margem_contribuicao: "",
        total_sem_ipi: "",
        total_com_ipi: "",
        custo_total: "",
        valor_venda_sem_ipi: 0,
        valor_venda_com_ipi: 0,
        info_tecdig:"",
      },
      rules: {
        numero_negocio: [
          {
            required: true,
            message: "Informe o Número do Negócio",
            trigger: "blur",
          },
        ],
        comissao: [
          {
            required: true,
            message: "Informe a Comissão",
            trigger: "blur",
          },
        ],
        revisao: [
          {
            required: true,
            message: "Informe a Revisão",
            trigger: "blur",
          },
        ],
      },

      fields: [],
      count: 0,
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.editar_painel) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    //LISTA DE CLIENTES - SGE
    axios
      .get(url + "/clientes", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listClientes = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

    //LISTA DE CIDADES ESTADOS - SGE
    axios
      .get(url + "/estadoscidades", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listEstados = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

    //TEC DIGITAL - SELECT LISTA
    axios
      .get(url + "/tecdigital", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.list_tec_digital = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

    if (this.$route.params.id) {
      axios
        .get(url + "/orcamentos_versao/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
        if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.ruleForm.numero_negocio = resp.data[0].sge_orcamento;
            this.ruleForm.cliente = resp.data[0].cliente; //OK

            // //REVISAO
            this.ruleForm.cidade = resp.data[0].cidade;
            this.ruleForm.estado = resp.data[0].estado;

            this.ruleForm.sge_cliente = resp.data[0].sge_cliente;
            this.ruleForm.sge_cidade = resp.data[0].sge_cidade;
            this.ruleForm.sge_estado = resp.data[0].sge_estado;

            let vers = 0;
            vers = Number(resp.data[0].revisao) + 1;
            this.ruleForm.revisao = vers;
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        })
        .finally(() => {
          if (
            this.ruleForm.sge_estado != "" &&
            this.ruleForm.sge_estado != undefined
          ) {
            this.buscaICMS();
          } else {
            this.$notify({
              title: "Aviso",
              message: "Informe o Estado do Cliente para calcular o ICMS!",
              type: "warning",
            });
          }
        });
    }

    //CONFIGURAÇÃO - BUSCA TODOS OS BENEFICIOS COLOCA EM UMA TABELA PARA VERIFICAÇÃO DURANTE O SISTEMA
    //E PARA NÃO PRECISAR FICAR IR BUSCANDO NA API TODA VEZ QUE PRECISAR DA INFORMAÇÃO
    //TABELA DE CONFIGURAÇÃO TAB_TRIBUTOS_CONFIG
    axios
      .get(url + "/config/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (this.list_tec_digital.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          for (let i = 0; i < resp.data.length; i++) {
            if (resp.data[i].slug == "pis_cofins") {
              let vl = new String(resp.data[i].valor);
              this.ruleForm.credito_pis_cofins = vl.replace(".", ",");
            }
            for (let x = 0; x < this.tab_tributos_config.length; x++) {
              if (resp.data[i].slug == this.tab_tributos_config[x].slug) {
                let vl = new String(resp.data[i].valor);
                this.tab_tributos_config[x].percentual = vl.replace(".", ",");
              }
            }
            this.verificaBeneficio();
            if (resp.data[i].slug == "comissao_externa") {
              this.ruleForm.comissao_externa = resp.data[i].valor;
            }
            if (resp.data[i].slug == "comissao_interna") {
              this.ruleForm.comissao = resp.data[i].valor;
            }
            if (resp.data[i].slug == "margem_contribuicao") {
              this.ruleForm.margem_contribuicao = resp.data[i].valor;
            }
            if (resp.data[i].slug == "icms_tec_dig") {
              this.icms_tec_dig = resp.data[i].valor;
            }
          }
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

    //CONFIGURAÇÃO - FUNÇÕES
    axios
      .get(url + "/config_funcoes", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (this.list_tec_digital.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listCmo = resp.data;
          this.ruleForm.array_dados = this.listCmo;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

    //BUSCA VALOR DA RENTABILIDADE
    this.$store
      .dispatch("listaRentabilidade", 1)
      .then((resp) => {
        this.ruleForm.rentabilidade = FuncoesUteis.formataDolarToReal(
          resp.data[0].valor
        );
      })
      .catch(() => {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/login");
        });
      });

    /////////////////////////PAINEIS////////////////////
    this.verificaBeneficio();
    ///////////////////////////////////////////////////
  },

  methods: {
    tabulacao(index) {
      let i = index;
      i = Number(index) + 1;

      i = new String(i);

      return i;
    },
    buscaCidades() {
      let est = "";
      if (this.ruleForm.estado != "") {
        est = this.ruleForm.estado;
      }
      this.listCidades = this.listEstados[est]["cidades"];
    },

    buscaICMS() {
      //Catana - 07/10/2020
      //se o estado for RS
      // e o beneficio5 (tecnologia digital) for Verdadeiro
      //ICMS esta no config
      //se o beneficio5 (tecnologia digital) for falso
      //ICMS esta na tabela de ICMS
      //se for qualquer outro estado puxa da tabela de ICMS o valor
      //
      //OBS: o beneficio5 só pode ser verdadeiro se for estado RS
      //e o NCM estiver na lista de tecnologia digital

      if (this.ruleForm.estado == "RS" && this.ruleForm.beneficio5 == true) {
        this.tab_tributos[4].percentual = FuncoesUteis.formataDolarToReal(
          Number(this.icms_tec_dig)
        );
      } else {
        axios
          .get(url + "/config_icms/" + this.ruleForm.estado, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((resp) => {
            if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.tab_tributos[4].percentual = FuncoesUteis.formataDolarToReal(
                Number(resp.data)
              );
            }
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message:
                "Erro ao pesquisar os dados de ICMS! Tente novamente mais tarde!" +
                err,
              type: "error",
            });
          });
      }
    },
    verificaBeneficio() {
      if (this.ruleForm.beneficio1 == true) {
        this.tab_tributos[3].percentual = "0,00";
        this.tab_tributos[3].valor = "0,00";
      } else {
        for (let i = 0; i < this.tab_tributos_config.length; i++) {
          if (this.tab_tributos_config[i].slug == "pis_cofins") {
            this.tab_tributos[3].percentual = this.tab_tributos_config[
              i
            ].percentual;
            break;
          }
        }
        this.tab_tributos[3].valor = "0,00";
      }

      // if (this.ruleForm.beneficio2 == true) {
      //IRPJ SEMPRE PAGA PORTANTO NÃO PRECISA PERGUNTAR SE TEM O BENEFICIO OU NÃO
      for (let i = 0; i < this.tab_tributos_config.length; i++) {
        if (this.tab_tributos_config[i].slug == "irpj") {
          this.tab_tributos[1].percentual = this.tab_tributos_config[
            i
          ].percentual;
          break;
        }
      }
      this.tab_tributos[1].valor = "0,00";
      // } else {
      //   this.tab_tributos[1].percentual = "0,00";
      //   this.tab_tributos[1].valor = "0,00";
      // }

      // if (this.ruleForm.beneficio3 == true) {
      //CSLL  sempre paga portanto não precisa perguntar se tem o beneficio ou não
      for (let i = 0; i < this.tab_tributos_config.length; i++) {
        if (this.tab_tributos_config[i].slug == "csll") {
          this.tab_tributos[2].percentual = this.tab_tributos_config[
            i
          ].percentual;
          break;
        }
      }
      this.tab_tributos[2].valor = "0,00";
      // } else {
      //   this.tab_tributos[2].percentual = "0,00";
      //   this.tab_tributos[2].valor = "0,00";
      // }

      if (this.ruleForm.beneficio4 == true) {
        this.tab_tributos[0].percentual = "0,00";
        this.tab_tributos[0].valor = "0,00";
      } else {
        this.tab_tributos[0].percentual =
          this.ruleForm.ipi != ""
            ? this.ruleForm.ipi != "NT"
              ? this.ruleForm.ipi
              : "0,00"
            : "0,00";
        this.tab_tributos[0].valor = "0,00";
      }
      if (this.ruleForm.beneficio5 == true) {
        this.ruleForm.info_tecdig =
          " Produtos de informática classificados na posição 8471 e nas subposições 8473.30, 8504.40 e 8534.00, e, desde que de tecnologia digital, nas posições 8536, 8537, 9029, 9030, 9031 e 9032, da NBM/SH-NCM, nas saídas do estabelecimento fabricante;";
        this.mostra_msg_tecdig=true;  
      } else {
        this.ruleForm.info_tecdig ="";
        this.mostra_msg_tecdig=false;      
      }
      this.buscaICMS();
    },

    getTotaisCustos(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (index === 1) {
          let dados = data.map((item) => item[column.property]);
          sums[index] = 0;
          for (let i = 0; i < dados.length; i++) {
            let vl = new String(dados[i]);
            vl = vl.replace(".", "");
            vl = vl.replace(",", ".");
            dados[i] = vl;
            sums[index] += parseFloat(dados[i]);
          }
          this.totalCusto = sums[index];
          sums[index] = FuncoesUteis.formataDolarToReal(sums[index]);
        }
      });
      return sums;
    },
    getTotaisTributos(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (index === 1) {
          let dados = data.map((item) => item[column.property]);
          sums[index] = 0;
          for (let i = 0; i < dados.length; i++) {
            dados[i] = FuncoesUteis.formataRealToDolar(dados[i]);
            sums[index] += parseFloat(dados[i]);
          }
          this.totalTributos = sums[index];
          sums[index] = FuncoesUteis.formataDolarToReal(sums[index]);
        }
        if (index === 2) {
          let dados = data.map((item) => item[column.property]);
          sums[index] = 0;
          for (let i = 0; i < dados.length; i++) {
            dados[i] = FuncoesUteis.formataRealToDolar(dados[i]);
            sums[index] += parseFloat(dados[i]);
          }
          sums[index] = FuncoesUteis.formataDolarToReal(sums[index]);
        }
      });

      // let preco_venda = FuncoesUteis.formataRealToDolar(this.ruleForm.valor_venda_sem_ipi);
      // let icms = FuncoesUteis.formataRealToDolar(this.tab_tributos[4].percentual);
      // let valoricms;
      // valoricms = ((Number(preco_venda))*Number(icms))/ 100;
      // //this.tab_tributos[4].valor = valoricms;

      // //this.tab_tributos[0].valor = (Number(preco_venda) * Number(ipi)) / 100;
      //this.somaVenda();
      return sums;
    },
    /////////////////////////////////////////////////////////

    //CADASTRO DADOS
    handleFechar() {
      if (this.esconde_botao == false) {
        this.$confirm("Tem certeza que deseja sair, sem salvar?", "Aviso", {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/orcamentos");
          })
          .catch(() => {
            return true;
          });
      } else {
        this.$router.push("/orcamentos");
      }
    },
    buscaCidadesClientes() {
      //encontra os códigos cliente cidade e estado
      let verifica;
      verifica = Number(this.ruleForm.sge_cliente);
      for (let i = 0; i < this.listClientes.length; i++) {
        if (this.listClientes[i].CODIGO == verifica) {
          for (var prop in this.listEstados) {
            if (
              this.listEstados[prop].codigo == this.listClientes[i].ESTD_CODIGO
            ) {
              this.ruleForm.estado = this.listEstados[prop].sigla;
              this.ruleForm.sge_estado = this.listEstados[prop].codigo;

              this.listCidades = this.listEstados[prop].cidades;
              this.ruleForm.sge_cidade = this.listClientes[i].MUNI_CODIGO;
              for (var propCid in this.listEstados[prop].cidades) {
                if (
                  this.listEstados[prop].cidades[propCid].codigo ==
                  this.listClientes[i].MUNI_CODIGO
                ) {
                  this.ruleForm.cidade = this.listEstados[prop].cidades[
                    propCid
                  ].descricao;
                  break;
                }
              }
              break;
            }
          }
          break;
        }
      }
    },

    submitForm(formName) {
      this.loading = true;
      this.esconde_botao = true;
      ///guarda o sge_cliente no seu devido lugar e busca a descrição da cidade do cliente
      if (Number.isInteger(this.ruleForm.sge_cliente) === true) {
        this.ruleForm.sge_cliente = this.ruleForm.cliente;
      }

      for (let i = 0; i < this.listClientes.length; i++) {
        if (this.listClientes[i].CODIGO == this.ruleForm.sge_cliente) {
          this.ruleForm.cliente = this.listClientes[i].NOME_FANTASIA;
          break;
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let ncm;
          ncm = this.ruleForm.ncm;
          ncm = ncm.replace(".", "");
          ncm = ncm.replace(".", "");

          let funcao = "";
          for (let i = 0; i < this.ruleForm.array_dados.length; i++) {
            funcao = funcao + this.ruleForm.array_dados[i].funcao + "|";
          }
          let ch = "";
          for (let i = 0; i < this.ruleForm.array_dados.length; i++) {
            ch = ch + this.ruleForm.array_dados[i].carga_horaria + "|";
          }
          let hn = "";
          for (let i = 0; i < this.ruleForm.array_dados.length; i++) {
            hn = hn + this.ruleForm.array_dados[i].hora_normal + "|";
          }
          let he50 = "";
          for (let i = 0; i < this.ruleForm.array_dados.length; i++) {
            he50 = he50 + this.ruleForm.array_dados[i].hora_extra_50 + "|";
          }
          let he100 = "";
          for (let i = 0; i < this.ruleForm.array_dados.length; i++) {
            he100 = he100 + this.ruleForm.array_dados[i].hora_extra_100 + "|";
          }
          let total = "";
          for (let i = 0; i < this.ruleForm.array_dados.length; i++) {
            let tt = "";
            tt = new String(this.ruleForm.array_dados[i].total);
            tt = tt.replace(".", "");
            tt = tt.replace(",", ".");
            total = total + tt + "|";
          }

          ///tributos preparação para enviar para salvar
          let tributos_desc = "";
          for (let i = 0; i < this.tab_tributos.length; i++) {
            tributos_desc =
              tributos_desc + this.tab_tributos[i].descricao + "|";
          }
          let tributos_slug = "";
          for (let i = 0; i < this.tab_tributos.length; i++) {
            tributos_slug = tributos_slug + this.tab_tributos[i].slug + "|";
          }
          let tributos_percentual = "";
          for (let i = 0; i < this.tab_tributos.length; i++) {
            tributos_percentual =
              tributos_percentual +
              FuncoesUteis.formataRealToDolar(this.tab_tributos[i].percentual) +
              "|";
          }
          let tributos_valor = "";
          for (let i = 0; i < this.tab_tributos.length; i++) {
            tributos_valor =
              tributos_valor +
              FuncoesUteis.formataRealToDolar(this.tab_tributos[i].valor) +
              "|";
          }

          //beneficio5 só pode ser true se estiver na lista de tec_dig o mcn
          if (this.ruleForm.beneficio5 == true) {
            let m = this.ruleForm.ncm.substr(0, 4);
            let teste = false;
            let i = 0;

            for (i = 0; i < this.list_tec_digital.length; i++) {
              if (this.list_tec_digital[i].descricao.length == 4) {
                m = this.ruleForm.ncm.substr(0, 4);
              } else {
                m = this.ruleForm.ncm.substr(0, 7);
              }
              if (m == this.list_tec_digital[i].descricao) {
                teste = true;
                break;
              }
            }
            if (teste == false) {
              this.$notify({
                title: "Erro",
                message:
                  "Não é possível salvar. Verifique beneficio Tecnologia Digital!",
                type: "error",
              });
              this.esconde_botao = false;
              return false;
            }
          }
          if (this.ruleForm.numero_negocio == "") {
            this.$notify({
              title: "Erro",
              message: "Não é possível salvar. Informe o número do Negócio!",
              type: "error",
            });
            this.esconde_botao = false;
            return false;
          }
          if (this.ruleForm.revisao == "") {
            this.$notify({
              title: "Erro",
              message: "Não é possível salvar. Informe o número da Revisão!",
              type: "error",
            });
            this.esconde_botao = false;
            return false;
          }

          if (
            this.ruleForm.ncm_descricao == "" ||
            this.ruleForm.ncm_descricao == null
          ) {
            this.$notify({
              title: "Erro",
              message: "Não é possível salvar. Informe um NCM válido!",
              type: "error",
            });
            this.esconde_botao = false;
            return false;
          }

          let dados = {
            sge_orcamento: this.ruleForm.numero_negocio,
            revisao: this.ruleForm.revisao,
            comissao: FuncoesUteis.formataRealToDolar(this.ruleForm.comissao),
            cliente: this.ruleForm.cliente,
            sge_cliente: this.ruleForm.sge_cliente,
            cidade: this.ruleForm.cidade,
            sge_cidade: this.ruleForm.sge_cidade,
            estado: this.ruleForm.estado,
            sge_estado: this.ruleForm.sge_estado,
            rentabilidade: FuncoesUteis.formataRealToDolar(this.ruleForm.rentabilidade),
            ncm_id: ncm,
            ncm_ncm: ncm,
            ncm_descricao: this.ruleForm.ncm_descricao,
            ncm_ipi: this.ruleForm.ipi,
            beneficio_pis_cofins: this.ruleForm.beneficio1,
            beneficio_irpj: this.ruleForm.beneficio2,
            beneficio_csll: this.ruleForm.beneficio3,
            beneficio_ipi: this.ruleForm.beneficio4,
            beneficio_tec_dig: this.ruleForm.beneficio5,
            info_tecdig: this.ruleForm.info_tecdig,
            total_diversos: FuncoesUteis.formataRealToDolar(
              this.ruleForm.total_diversos
            ),
            totalGeral: FuncoesUteis.formataRealToDolar(
              this.ruleForm.totalGeral
            ),
            art: FuncoesUteis.formataRealToDolar(this.ruleForm.art),
            outros: FuncoesUteis.formataRealToDolar(this.ruleForm.outros),
            custo_materia_prima: FuncoesUteis.formataRealToDolar(
              this.ruleForm.cmp
            ),
            credito_pis_cofins: FuncoesUteis.formataRealToDolar(
              this.ruleForm.credito_pis_cofins
            ),
            rentab_desejada: FuncoesUteis.formataRealToDolar(
              this.valor_rentabilidade_desejada
            ),
            venda_sem_ipi: FuncoesUteis.formataRealToDolar(
              this.ruleForm.valor_venda_sem_ipi
            ),
            venda_com_ipi: FuncoesUteis.formataRealToDolar(
              this.ruleForm.valor_venda_com_ipi
            ),
            faturamento_direto: FuncoesUteis.formataRealToDolar(
              this.ruleForm.faturamento_direto
            ),
            margem_contribuicao: FuncoesUteis.formataRealToDolar(
              this.ruleForm.margem_contribuicao
            ),
            comissao_externa: FuncoesUteis.formataRealToDolar(
              this.ruleForm.comissao_externa
            ),
            total_materia_prima: FuncoesUteis.formataRealToDolar(
              this.ruleForm.total_materia_prima
            ),
            custo_total: FuncoesUteis.formataRealToDolar(
              this.ruleForm.custo_total
            ),
            percentual_faturamento_direto: FuncoesUteis.formataRealToDolar(
              this.ruleForm.percentual_faturamento_direto
            ),
            status: 1,

            cmo_funcao: funcao,
            cmo_carga_horaria: ch,
            cmo_hora_normal: hn,
            cmo_hora_extra_50: he50,
            cmo_hora_extra_100: he100,
            cmo_total: total,

            trib_descricao: tributos_desc,
            trib_slug: tributos_slug,
            trib_percentual: tributos_percentual,
            trib_valor: tributos_valor,
          };
          axios
            .post(url + "/orcregister/", dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro salvo com Sucesso!",
                type: "success",
              });
              this.esconde_botao = true;
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.esconde_botao = false;
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          this.esconde_botao = false;
          return false;
        }
      });
    },
    //FIM CADASTRO DADOS
    /**NEGOCIO/ */
    onNegocioClick: function (e) {
      if (e.DPES_CODIGO) {
        this.ruleForm.numero_negocio = e.NUMERO_NEGOCIO;
        this.ruleForm.revisao = 1;
        let idPessoa = e.DPES_CODIGO;
        axios
          .get(url + "/pessoa/" + idPessoa, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((resp) => {
            if (this.list_tec_digital.status == "Token is Expired") {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.ruleForm.cliente = resp.data.razao_social;
              this.ruleForm.cidade = resp.data.municipio;
              this.ruleForm.estado = resp.data.estado_sigla;

              this.ruleForm.sge_cliente = resp.data.dpes_codigo;
              this.ruleForm.sge_cidade = resp.data.cod_municipio;
              this.ruleForm.sge_estado = resp.data.cod_estado;

              this.buscaICMS();
            }
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message:
                "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
              type: "error",
            });
          });
      }
    },
    /**NCM/ */
    onNcmClick: function (e) {
      if (e != null) {
        this.desabilita_tec_dig = true;
        this.ruleForm.ncm = e.ncm;
        this.ruleForm.ncm_descricao = e.descricao;
        this.ruleForm.ipi = e.ipi;
        if (this.ruleForm.estado == "RS") {
          let verifica;
          for (let i = 0; i < this.list_tec_digital.length; i++) {
            this.list_tec_digital[i].descricao = new String(
              this.list_tec_digital[i].descricao
            );
            verifica = this.ruleForm.ncm.substr(
              0,
              this.list_tec_digital[i].descricao.length
            );
            if (this.list_tec_digital[i].descricao == verifica) {
              this.desabilita_tec_dig = false;
            }
          }
        }
      }
    },

    envia_para_tec_dig_desc() {
      this.ruleForm.tec_dig_desc = this.list_tec_digital[
        this.ruleForm.tec_dig_id - 1
      ].descricao;
    },
    /*CMO*/
    onCmoClick: function (e) {
      let dados = {
        funcao: e.funcao,
        carga_horaria: e.carga_horaria,
        hora_normal: e.hora_normal,
        hora_extra_50: e.hora_extra_50,
        hora_extra_100: e.hora_extra_100,
        total: e.total,
      };
      this.listCmo.push(dados);

      this.ruleForm.array_dados = this.listCmo;
    },

    handleDeleteCmo(index) {
      this.listCmo.splice(index, 1);
      this.ruleForm.array_dados = this.listCmo;
    },

    /***************************************************/
    getTotais(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totais";
          return;
        }
        let dados = data.map((item) => item[column.property]);
        if (index === 1) {
          sums[index] = "";
        }

        if (index > 1 && index < 5) {
          for (let i = 0; i < dados.length; i++) {
            if (sums[index] === undefined) {
              sums[index] = 0;
            }

            if (dados[i] == "") {
              dados[i] = 0;
            } else if (dados[i] == null) {
              dados[i] = 0;
            }
            sums[index] += parseFloat(dados[i]);
          }
        }
        if (index === 5) {
          for (let i = 0; i < dados.length; i++) {
            if (sums[index] === undefined) {
              sums[index] = 0;
            } else if (sums[index] === "") {
              sums[index] = 0;
            } else if (isNaN(sums[index])) {
              sums[index] = 0;
            }

            let vl = new String(dados[i]);
            vl = vl.replace(".", "");
            vl = vl.replace(",", ".");
            dados[i] = vl;
            sums[index] += parseFloat(dados[i]);
          }
          if (isNaN(sums[index])) {
            sums[index] = 0;
          } else {
            sums[index] = parseFloat(sums[index]);
            sums[index] = sums[index].toFixed(2);
            let vl = new String(sums[index]);
            vl = vl.replace(",", "");
            vl = vl.replace(".", ",");
            sums[index] = vl;
          }
        }
      });

      //////soma o total geral/////
      // let vlart = this.ruleForm.art;
      // if (this.ruleForm.art != "") {
      //   vlart = FuncoesUteis.formataRealToDolar(vlart);
      // } else {
      //   vlart = 0.0;
      // }
      // let vloutros = this.ruleForm.outros;
      // if (this.ruleForm.outros != "") {
      //   vloutros = FuncoesUteis.formataRealToDolar(vloutros);
      // } else {
      //   vloutros = 0.0;
      // }
      let soma = sums[5]; //new String(sums[5]);
      if (soma != "" || soma != 0) {
        soma = FuncoesUteis.formataRealToDolar(soma);
      } else {
        soma = 0.0;
      }
      let total;

      //total parcial para calcular total_materia_prima
      // let somaparcial = 0;
      // somaparcial = Number(vlart) + Number(vloutros);
      // let sp=somaparcial;

      total = Number(soma);
      //  let tmo = 0;
      //  tmo = total;

      total = FuncoesUteis.formataDolarToReal(total);
      //  somaparcial = FuncoesUteis.formataDolarToReal(somaparcial);

      this.ruleForm.totalGeral = total;
      //this.ruleForm.total_diversos = somaparcial;

      //       ////total materia prima
      //       //total_materia_prima = custo_mp - (custo_mp*credito_pis_cofins) + fat_diireto*%faturamento_direto+total_parcial
      //       let custo_credito = 0;
      //       custo_credito = Number(FuncoesUteis.formataRealToDolar(this.ruleForm.cmp))*Number(FuncoesUteis.formataRealToDolar(this.ruleForm.credito_pis_cofins))/100;
      //       let mp=0;
      //       mp = Number(FuncoesUteis.formataRealToDolar(this.ruleForm.cmp)) - custo_credito ;
      //       // let fd = 0;
      //       // fd = Number(FuncoesUteis.formataRealToDolar(this.ruleForm.faturamento_direto))*Number(FuncoesUteis.formataRealToDolar(this.ruleForm.percentual_faturamento_direto))/100;
      //       let tmp = 0;
      //       let fd = 0;
      //       let pfd=0;
      //       fd = FuncoesUteis.formataRealToDolar(this.ruleForm.faturamento_direto);

      //       pfd = Number(fd)*Number(FuncoesUteis.formataRealToDolar(this.ruleForm.percentual_faturamento_direto))/100;
      //       // tmp = Number(sp)+Number(fd)+Number(mp);
      // //      tmp = Number(sp) + Number(pfd) + Number(mp);
      // tmp = pfd;

      //       this.ruleForm.total_materia_prima = tmp;
      //       this.ruleForm.custo_total = FuncoesUteis.formataDolarToReal(Number(tmp)+Number(tmo));

      //       this.tab_custos[1].valor = total;
      //       this.tab_custos[0].valor = this.ruleForm.cmp;

      return sums;
    },

    calculaTotais: function () {
      //verifica se foi informado o numero do negocio para buscar o ICMS
      //e o NCM para poder buscar o IPI
      //se não tiver estas informações não faz os calculos
      if (this.ruleForm.numero_negocio == "") {
        this.$notify({
          title: "Erro",
          message: "Informe o número do negócio para calcular os totais!",
          type: "error",
        });
        return false;
      } else if (this.ruleForm.ncm == "") {
        this.$notify({
          title: "Erro",
          message: "Informe o NCM para calcular os totais!",
          type: "error",
        });
        return false;
      }

      let vlart = this.ruleForm.art;
      if (this.ruleForm.art != "") {
        vlart = FuncoesUteis.formataRealToDolar(vlart);
      } else {
        vlart = 0.0;
      }
      let vloutros = this.ruleForm.outros;
      if (this.ruleForm.outros != "") {
        vloutros = FuncoesUteis.formataRealToDolar(vloutros);
      } else {
        vloutros = 0.0;
      }
      let total;
      total = FuncoesUteis.formataRealToDolar(this.ruleForm.totalGeral);
      let tmo = 0;
      tmo = total;
      //total parcial para calcular total_materia_prima
      let somaparcial = 0;
      somaparcial = Number(vlart) + Number(vloutros);
      let sp = somaparcial;
      somaparcial = FuncoesUteis.formataDolarToReal(somaparcial);
      this.ruleForm.total_diversos = somaparcial;

      ////total materia prima
      //total_materia_prima = custo_mp - (custo_mp*credito_pis_cofins) + fat_diireto*%faturamento_direto+total_parcial
      let custo_credito = 0;
      custo_credito =
        (Number(FuncoesUteis.formataRealToDolar(this.ruleForm.cmp)) *
          Number(
            FuncoesUteis.formataRealToDolar(this.ruleForm.credito_pis_cofins)
          )) /
        100;
      let mp = 0;
      mp =
        Number(FuncoesUteis.formataRealToDolar(this.ruleForm.cmp)) -
        custo_credito;

      let tmp = 0;
      let fd = 0;
      let pfd = 0;
      fd = FuncoesUteis.formataRealToDolar(this.ruleForm.faturamento_direto);
      pfd =
        (Number(fd) *
          Number(
            FuncoesUteis.formataRealToDolar(
              this.ruleForm.percentual_faturamento_direto
            )
          )) /
        100;
      tmp = Number(sp) + Number(pfd) + Number(mp);

      this.ruleForm.total_materia_prima = FuncoesUteis.formataDolarToReal(tmp);
      this.ruleForm.custo_total = FuncoesUteis.formataDolarToReal(
        Number(tmp) + Number(tmo)
      );

      ////////////////////////////////////////////////////////////////////
      //ci = comissao interna
      //ce = comissao externa
      //mc = margem contribuição
      //l = lucro
      //ml = l / 1(-0,25+0,09) = l/0,66
      //preco liquido =   custo total / 1 - (ci*1,9+ce+mc+ml)
      //preço venda = preço liquido / 1-(pis+cofins+icms)
      //preço de venda com ipi = preço venda + preço venda * ipi
      let ci = FuncoesUteis.formataRealToDolar(this.ruleForm.comissao);
      let ce = FuncoesUteis.formataRealToDolar(this.ruleForm.comissao_externa);
      let mc = FuncoesUteis.formataRealToDolar(
        this.ruleForm.margem_contribuicao
      );
      let ipi = FuncoesUteis.formataRealToDolar(this.tab_tributos[0].percentual);//FuncoesUteis.formataRealToDolar(this.ruleForm.ipi);
      let l = FuncoesUteis.formataRealToDolar(this.ruleForm.rentabilidade);
      let irpj = FuncoesUteis.formataRealToDolar(
        this.tab_tributos_config[1].percentual
      );
      let csll = FuncoesUteis.formataRealToDolar(
        this.tab_tributos_config[2].percentual
      );
      let pis_cofins = FuncoesUteis.formataRealToDolar(
        this.tab_tributos_config[3].percentual
      );

      let ml = l / (1 - (Number(irpj) + Number(csll)) / 100);
      let pl2 =
        1 -
        ((Number(ci) * 1.9) / 100 +
          (Number(ce) + Number(mc) + Number(ml)) / 100);
      let pl1 = FuncoesUteis.formataRealToDolar(this.ruleForm.custo_total);
      let preco_liquido = Number(pl1) / Number(pl2);

      let icms = FuncoesUteis.formataRealToDolar(
        this.tab_tributos[4].percentual
      );
      let pv2 = 1 - (Number(pis_cofins) + Number(icms)) / 100;
      let preco_venda = preco_liquido / pv2;

      let preco_venda_com_ipi =
        preco_venda + (Number(preco_venda) * Number(ipi)) / 100;

      this.ruleForm.valor_venda_sem_ipi = FuncoesUteis.formataDolarToReal(
        preco_venda
      );
      this.ruleForm.valor_venda_com_ipi = FuncoesUteis.formataDolarToReal(
        preco_venda_com_ipi
      );

      //icms
      this.tab_tributos[4].valor = FuncoesUteis.formataDolarToReal(
        (preco_venda * icms) / 100
      );
      //ipi
      //this.tab_tributos[0].percentual=FuncoesUteis.formataDolarToReal(ipi);
      this.tab_tributos[0].valor = FuncoesUteis.formataDolarToReal(
        (preco_venda *
          FuncoesUteis.formataRealToDolar(this.tab_tributos[0].percentual)) /
          100
      );
      //irpj
      this.tab_tributos[1].valor = FuncoesUteis.formataDolarToReal(
        (preco_venda *
          FuncoesUteis.formataRealToDolar(this.tab_tributos[1].percentual)) /
          100
      );
      //csll
      this.tab_tributos[2].valor = FuncoesUteis.formataDolarToReal(
        (preco_venda *
          FuncoesUteis.formataRealToDolar(this.tab_tributos[2].percentual)) /
          100
      );
      //pis/cofins
      this.tab_tributos[3].valor = FuncoesUteis.formataDolarToReal(
        (preco_venda *
          FuncoesUteis.formataRealToDolar(this.tab_tributos[3].percentual)) /
          100
      );

      ///verificar isto aqui mais tarde
      //this.tab_custos[1].valor = total;
      //this.tab_custos[0].valor = this.ruleForm.cmp;
    },
    /***************************************************/
    calculaTotal: function () {
      let ch = 0;
      ch = this.listCmo;

      for (let i = 0; i < ch.length; i++) {
        let he50 = 0;
        let he100 = 0;
        let hn = 0;
        if (ch[i].hora_normal === undefined || ch[i].hora_normal === "") {
          hn = 0;
        } else {
          hn = ch[i].hora_normal;
        }
        if (ch[i].hora_extra_50 === undefined || ch[i].hora_extra_50 === "") {
          he50 = 0;
        } else {
          he50 = ch[i].hora_extra_50;
        }
        if (ch[i].hora_extra_100 === undefined || ch[i].hora_extra_100 === "") {
          he100 = 0;
        } else {
          he100 = ch[i].hora_extra_100;
        }
        he50 = parseFloat(he50) * 1.5;
        he100 = parseFloat(he100) * 2;
        let tot_hora = 0;
        tot_hora = he50 + he100 + parseInt(hn);

        ch[i].total = parseFloat(ch[i].carga_horaria) * tot_hora;
        if (isNaN(ch[i].total)) {
          ch[i].total = 0;
        }
        let vl = new String(ch[i].total.toFixed(2));
        vl = vl.replace(",", "");
        vl = vl.replace(".", ",");

        ch[i].total = vl;

        this.listCmo.splice(i, 1, ch[i]);
      }
    },
    buscarPainelOrcamentoNumero() {
      axios
        .get(url + "/negocio_orcamento_numero/"+this.ruleForm.numero_negocio, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
        })
        .then((resp) => {
          if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            // console.log('#CDS', resp.data);
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });
    },
    buscarPainelOrcamentoItemSGE() {
      axios
        .get(url + "/negocio_orcamento_item_sge", {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
        })
        .then((resp) => {
          if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            // console.log(resp.data);
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });
    },  
    /***************************************************** */
    /************* BUSCA NUMERO E DADOS DO NEGÓCIO******** */
    /***************************************************** */
    buscaNumeroNegocio: function () {
      if (this.ruleForm.numero_negocio != "") {
        axios
          .get(url + "/negocio_numero/" + this.ruleForm.numero_negocio, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((resp) => {
            if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              if (resp.data.mensagem != "OK") {
                this.$notify({
                  title: "Erro",
                  message: resp.data.mensagem,
                  type: "error",
                });

                // this.ruleForm.numero_negocio = "";
                this.ruleForm.cliente = ""; //OK
                //REVISAO
                this.ruleForm.cidade = "";
                this.ruleForm.estado = "";

                this.ruleForm.sge_cliente = "";
                this.ruleForm.sge_cidade = "";
                this.ruleForm.sge_estado = "";

                this.ruleForm.revisao = "";
              } else {
                //REVISAO
                if (resp.data.municipio[0].length <= 1) {
                  this.ruleForm.cidade = resp.data.municipio;
                  this.ruleForm.estado = resp.data.estado;
                  this.ruleForm.cliente = resp.data.cliente; //OK
                } else {
                  this.ruleForm.cidade = resp.data.municipio[0];
                  this.ruleForm.estado = resp.data.estado[0];
                  this.ruleForm.cliente = resp.data.cliente[0]; //OK
                }

                this.ruleForm.sge_cliente = resp.data.codigo_cliente;
                this.ruleForm.sge_cidade = resp.data.codigo_municipio;
                this.ruleForm.sge_estado = resp.data.codigo_estado;

                this.ruleForm.revisao = resp.data.versao;
              }
            }
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message:
                "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
              type: "error",
            });
          })
          .finally(() => {
            if (
              this.ruleForm.sge_estado != "" &&
              this.ruleForm.sge_estado != undefined
            ) {
              this.buscaICMS();
            } else {
              this.$notify({
                title: "Aviso",
                message: "Informe o Estado do Cliente para calcular o ICMS!",
                type: "warning",
              });
            }
          });
      } else {
        this.ruleForm.numero_negocio = "";
        this.ruleForm.cliente = ""; //OK
        //REVISAO
        this.ruleForm.cidade = "";
        this.ruleForm.estado = "";

        this.ruleForm.sge_cliente = "";
        this.ruleForm.sge_cidade = "";
        this.ruleForm.sge_estado = "";

        this.ruleForm.revisao = "";
      }
    },
    /*******************************************************/
    /******************** BUSCA NUMERO NCM *****************/
    /*******************************************************/
    buscaNcm: function () {
      this.desabilita_tec_dig = true;
      let ncm;
      ncm = this.ruleForm.ncm;

      ncm = ncm.replace(".", "");
      ncm = ncm.replace(".", "");

      this.ruleForm.ipi = "";
      this.ruleForm.ncm_descricao = "";
      if (ncm != "") {
        axios
          .get(url + "/busca_ncm/" + ncm, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((resp) => {
            if (resp.status == "Token is Expired" || resp.status == "Token is Invalid" || resp.status == "Authorization Token not found") {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              if (resp.data.mensagem != "OK") {
                this.$notify({
                  title: "Erro",
                  message: resp.data.mensagem,
                  type: "error",
                });

                this.ruleForm.ipi = "";
                this.tab_tributos[0].percentual = 0;
                this.ruleForm.ncm_descricao = ""; //OK
              } else {
                this.ruleForm.ipi = resp.data.dados[0].ipi; //OK
                this.tab_tributos[0].percentual = resp.data.dados[0].ipi;
                this.ruleForm.ncm_descricao = resp.data.dados[0].descricao;
              }
            }
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message:
                "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
              type: "error",
            });
          })
          .finally(() => {
            if (this.ruleForm.estado == "RS") {
              let verifica;
              for (let i = 0; i < this.list_tec_digital.length; i++) {
                this.list_tec_digital[i].descricao = new String(
                  this.list_tec_digital[i].descricao
                );
                verifica = this.ruleForm.ncm.substr(
                  0,
                  this.list_tec_digital[i].descricao.length
                );
                if (this.list_tec_digital[i].descricao == verifica) {
                  this.desabilita_tec_dig = false;
                }
              }
            }
          });
      } else {
        this.ruleForm.ipi = "";
        this.ruleForm.ncm_descricao = "";
      }
    },
  },
};
</script>
<style>
.bg-purple-light {
  background: #303133;
}
.CadastroUsuarios .grid-content {
  border-radius: 4px;
  min-height: 2px;
  height: 2px;
}

.tec_select label {
  width: 100%;
  text-align: left;
}
.tec_select div {
  width: 100%;
  text-align: left;
}
.encontrar_orc_left {
  text-align: left;
}
.lista_ncm {
  text-align: left;
  margin-bottom: 0px;
  margin-top: 10px;
}

.CadastroUsuarios .el-table td,
.el-table th {
  padding: 0px 0 !important;
}
.tabela_cmo .item {
  margin-bottom: 0px !important;
}

.CadastroUsuarios .label_campos {
  /* font-weight: bold; */
  width: 100%;
  display: block;
  padding: 5px 0px;
  margin-top: 0px;
}
.CadastroUsuarios .input_campos {
  font-weight: bold;
  width: 80%;
  display: block;
  border-radius: 5px;
  border: 1px solid #e4e7ed;
  background: #faecd8;
  height: 25px;
  padding-left: 15px;
  padding-top: 10px;
}
.CadastroUsuarios .input_campos_total {
  font-weight: bold;
  width: 80%;
  display: block;
  border-radius: 5px;
  border: 1px solid #e4e7ed;
  background: #e1f3d8;
  height: 25px;
  padding-left: 15px;
  padding-top: 10px;
}
.CadastroUsuarios .espaco_top {
  margin-top: 8px;
  text-align: left;
  padding: 5px 0px;
}
.CadastroUsuarios .listas label {
  width: 100%;
  text-align: left;
}
.CadastroUsuarios .listas .el-input__suffix-inner {
  padding-top: 0px;
  top: 0px !important;
  position: absolute;
  margin-left: -20px;
  margin-top: 40px;
}
.CadastroUsuarios .listas .el-select {
  width: 100%;
  display: block;
}
</style>